import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "auth-callback" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "error"
}

import { useRouter, useRoute } from 'vue-router'
import { supabase } from '@/lib/supabase'
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmEmail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const error = ref<string | null>(null)


onMounted(async () => {
  if (route.query.code) {
    try {
      const { data, error } = await supabase.auth.exchangeCodeForSession(route.query as any)
      
      if (error) {
        console.log("Error confirming email :(")
        router.push("/home")
      } else {
        router.push("/home")
      }
    } catch (err) {
      router.push("/home")
    }
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Confirming your email...", -1)
        ])))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(error.value), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})